export default __webpack_public_path__ + "static/media/laser_eyes.acf04781.png";